import { AxiosResponse } from "axios";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getExceedDuration(
  downloadedTimeStamp: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  response: AxiosResponse<any>,
): boolean {
  // Check if isDownloadApd exceeds the duration
  const currentTime = Date.now();
  const downloadTime = new Date(downloadedTimeStamp).getTime(); // Parse ISO 8601 format to timestamp
  const elapsedMinutes = (currentTime - downloadTime) / 60000; // Calculate elapsed time in minutes
  const durationInMinutes = response.data.data.content[0]?.value || 0;

  return durationInMinutes < elapsedMinutes;
}
